import {
  useQuery,
  UseQueryResult,
} from "@tanstack/react-query";
import { GetAllSitesList } from "../api";

type GetSiteListsProps = {
  authToken: string;
  leftPanelOpen?: boolean;
};

type Group = {
  groupName: string;
  deviceCount: number | string;
};

type Site = {
  siteName: string;
  siteLocation?: string;
  groups: Group[];
};

type SiteList = {
  status: string;
  siteList: Site[];
};

export const useGetSiteLists = (
  options: GetSiteListsProps
): UseQueryResult<SiteList, Error> => {
  const { authToken, leftPanelOpen } = options;
  return useQuery({
    queryKey: ["getSiteLists"],
    queryFn: ({ queryKey }) => GetAllSitesList(authToken),
    enabled:
      leftPanelOpen === undefined
        ? !!authToken
        : !!authToken && leftPanelOpen,
    staleTime: 0,
    notifyOnChangeProps: "all",
  });
};
